import { DateTime as DateTime$1 } from "../../../../../components/DateTime/index.js";
import { useLocation } from "../../../../Locations/hooks/useLocation.js";
import { IdLabel } from "../../../../../components/IdLabel/index.js";
import { LocationName } from "../../../../Locations/shared/LocationName.js";
import { Tags } from "../../../../Tags/shared/Tags.js";
import "react";
import { CopyText, Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { formatAddress } from "@therms/web-js";
//#region src/modules/Events/shared/EventPresentation/components/EventDetails.tsx
function EventDetails({ event, hideEventName }) {
	const { data: locationData } = useLocation({ locationId: event.locationId });
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-sm flex flex-col",
		children: [
			!hideEventName && /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xxs flex items-baseline",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-lg",
					children: event.title
				}), /* @__PURE__ */ jsx(IdLabel, {
					className: "traking-wide text-color-subtle text-sm font-bold",
					idLabel: event.idLabel
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "gap-x-sm inline-flex w-full",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex w-full flex-col",
					children: [
						/* @__PURE__ */ jsx(Label, { children: "Location" }),
						/* @__PURE__ */ jsxs("span", {
							className: "text-color-strong gap-x-xxs flex",
							children: [/* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(LocationName, { locationId: event.locationId }) }), event.subLocationId && /* @__PURE__ */ jsxs("span", {
								className: "gap-x-xxs flex",
								children: [/* @__PURE__ */ jsx("span", { children: "/" }), /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(LocationName, { locationId: event.subLocationId }) })]
							})]
						}),
						!!locationData?.location?.address && /* @__PURE__ */ jsx(CopyText, {
							value: formatAddress(locationData.location.address),
							children: /* @__PURE__ */ jsx("span", {
								className: "font-light",
								children: formatAddress(locationData.location.address, true)
							})
						})
					]
				}), /* @__PURE__ */ jsxs("div", {
					className: "flex w-full flex-col",
					children: [/* @__PURE__ */ jsx(Label, { children: "Time" }), /* @__PURE__ */ jsx("div", {
						className: "gap-x-sm inline-flex",
						children: /* @__PURE__ */ jsx("span", {
							className: "text-color-strong",
							children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: event.date })
						})
					})]
				})]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "grow",
				children: /* @__PURE__ */ jsx(Tags, { tags: event.activityTypeTags })
			})
		]
	});
}
//#endregion
export { EventDetails };

//# sourceMappingURL=EventDetails.js.map